//#region src/lib/sentry/sentryReplayCanvasMode.ts
var e = [
	"off",
	"manual",
	"auto"
], t = [
	"low",
	"medium",
	"high"
], n = Object.freeze((() => {
	let n = {
		mode: "auto",
		quality: "medium"
	};
	if (typeof window > "u") return n;
	let r = new URLSearchParams(window.location.search), i = r.get("sentyReplayCanvasMode"), a = r.get("SentryReplayCanvasQuality");
	return {
		mode: e.find((e) => e === i) ?? n.mode,
		quality: t.find((e) => e === a) ?? n.quality
	};
})());
//#endregion
export { n as sentryReplayCanvasConfig };
